<div class="dvb-image-blob-preview" ng-if="!!vm.uri">
    <img ng-src="{{vm.uri}}" alt="">
</div>
